import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { UserService } from '../../services/user.service';
import { LinkService } from '../../services/link.service';
import firebase from '@firebase/app';
import '@firebase/firestore';
import * as moment from 'moment';
import * as momentTz from 'moment-timezone';
import * as _ from 'lodash';
import { Title } from '@angular/platform-browser';

@Component({
  selector: 'page-display',
  templateUrl: 'display.html',
})
export class DisplayPage implements OnInit, OnDestroy {
  
  db;
  
  client;
  profile: any;
  displayLinks = [];
  displayLinksSub: any;
  settings;
  timezonePref;

  utmAddon: any = '';
  pixelLoaded = false;

  userService;
  linkService;

  constructor(
    public router: Router,
    public route: ActivatedRoute,
    public titleService: Title,
  ) {
    this.userService = new UserService();
    this.linkService = new LinkService();
    // this.db = firebase.firestore('https://bitl-it-analytics.firebaseapp.com/');
  }

  ngOnInit() {
    let routeSub = this.route.params.subscribe(async (params) => {
      this.profile = await this.userService.getProfileByUsername(params['username']);
      if (!this.profile) {
        this.goTo('404');
        return;
      }
      if (this.profile.$id) {
        this.settings = await this.userService.getUserSettings(this.profile.$id);
        if (params['username'] && this.settings.pageTitle) {
          this.titleService.setTitle(this.settings.pageTitle);
        } else {
          this.titleService.setTitle(params['username'] + ' | BitL.it')
        }
        this.timezonePref = this.settings.timezone || momentTz.tz.guess();
        if (this.settings && this.settings.pixelId) {
          localStorage.setItem('pixelId', this.settings.pixelId);
          this.pixelLoaded = true;
        }
        if (this.settings && this.settings.utmParams && this.settings.utmParams.active) {
          this.utmAddon = `?utm_source=${this.settings.utmParams.source}&utm_medium=${this.settings.utmParams.medium}`;
        }
        this.displayLinksSub = this.linkService.getUserLinksSub(this.profile.$id).onSnapshot((data) => {
          this.displayLinks = [];
          data.forEach((doc) => {
            let tempDoc = doc.data();
            if (tempDoc && tempDoc.url) {
              tempDoc.url = tempDoc.url.replace('https://', '').replace('http://', '');
            }
            this.displayLinks.push(tempDoc);
          });
          this.displayLinks = _.sortBy(this.displayLinks, 'displayOrder');
        });
        await this.userService.addView(this.profile.$id)
      }
      routeSub.unsubscribe();
    });
  }

  addClick(link) {
    this.userService.addClick(link.$id);
  }
  
  goTo(page) {
    switch(page) {
      case '404':
        this.router.navigate(['/404']);
        break;
      case 'contact':
        // window.location.href = 'contact';
        break;
      default:
        break;
    }
  }

  ngOnDestroy() {
    if (this.displayLinksSub) this.displayLinksSub();
  }

}



// WEBPACK FOOTER //
// ./src/pages/display/display.ts